"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterEndpointKeys = void 0;
var ClusterEndpointKeys;
(function (ClusterEndpointKeys) {
    ClusterEndpointKeys["GetCluster"] = "get.cluster";
})(ClusterEndpointKeys || (exports.ClusterEndpointKeys = ClusterEndpointKeys = {}));
